// extracted by mini-css-extract-plugin
module.exports = {"container":"CallUs-module__container___RWLYv","content":"CallUs-module__content___q5rmj","text":"CallUs-module__text___BG2Y3","number":"CallUs-module__number___xFhCk"};